var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({class:[
        'custom-buttom',
        {'active': _vm.isActive}
]},_vm.$listeners),[_c('span',{staticClass:"custom-buttom__text"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }